import { render, staticRenderFns } from "./download-excel.vue?vue&type=template&id=22c62896&scoped=true&"
import script from "./download-excel.vue?vue&type=script&lang=js&"
export * from "./download-excel.vue?vue&type=script&lang=js&"
import style0 from "./download-excel.vue?vue&type=style&index=0&id=22c62896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c62896",
  null
  
)

export default component.exports